<div style="padding: 40px; max-width: 800px; margin: 0 auto;">
	<h1>Cue WhatsApp Widget Test Page</h1>
	<p>This page tests the Cue WhatsApp widget integration with custom data.</p>

	<div style="background: #f5f5f5; padding: 20px; margin: 20px 0; border-radius: 8px;">
		<h2>Widget Status</h2>
		<p><strong>Widget ID:</strong> dd018d69-d97d-441b-a3aa-a23455522bb7</p>
		<p><strong>Widget Ready:</strong> <span [style.color]="widgetReady ? 'green' : 'orange'">{{ widgetReady ? '✓ Yes' : '⏳ Loading...' }}</span></p>
	</div>

	<div style="background: #e3f2fd; padding: 20px; margin: 20px 0; border-radius: 8px;">
		<h2>Expected Behavior</h2>
		<ul>
			<li>You should see a <strong>green WhatsApp button</strong> in the bottom-right corner</li>
			<li>Open browser console (F12) to see widget logs</li>
			<li>Click the widget to open the chat interface</li>
			<li>Custom data is automatically sent when page loads</li>
		</ul>
	</div>

	<div style="background: #fff3e0; padding: 20px; margin: 20px 0; border-radius: 8px;">
		<h2>Test Custom Data</h2>
		<p>Click the button below to manually send test data to the widget:</p>
		<button
			(click)="sendTestData()"
			style="background: #25D366; color: white; padding: 12px 24px; border: none; border-radius: 4px; cursor: pointer; font-size: 16px;">
			Send Test Data
		</button>
		<p *ngIf="testDataSent" style="color: green; margin-top: 10px;">✓ Test data sent successfully!</p>
	</div>

	<div style="background: #f5f5f5; padding: 20px; margin: 20px 0; border-radius: 8px;">
		<h2>Console Commands</h2>
		<p>Open browser console (F12) and check for these messages:</p>
		<ul>
			<li><code>✅ CueWidget is ready</code></li>
			<li><code>CueWidget: Session data updated</code></li>
		</ul>
	</div>

	<div style="margin-top: 40px;">
		<a routerLink="/" style="color: #1976d2; text-decoration: none;">← Back to Home</a>
	</div>
</div>
